import { post, get } from './base';

export const logout = () => {
	return post('/api/auth/logout');
};

export const getUserProfile = async () => {
	return get('/api/auth/user');
};
